import { ReactNode } from 'react';
import { UiIcon } from '@frontend/znanie-uikit';

import css from './LoadingContainer.module.scss';

interface ILoadingContainerProps {
  children: ReactNode;
}

export default function LoadingContainer({ children }: ILoadingContainerProps) {
  return (
    <div className={css.block}>
      {children}
      <UiIcon name="animated-spinner" size={100} />
    </div>
  );
}
